import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7552fe28")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "header" }, "Configuración", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Guardar")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Cargar")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Number = _resolveComponent("Number")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_TGSelect = _resolveComponent("TGSelect")!
  const _component_SettingsGroup = _resolveComponent("SettingsGroup")!
  const _component_TgToggle = _resolveComponent("TgToggle")!
  const _component_color_picker = _resolveComponent("color-picker")!
  const _component_TgButton = _resolveComponent("TgButton")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createBlock(_component_BaseModal, {
    show: _ctx.showModal,
    class: "settings-modal",
    onClose: _ctx.closeModal
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_SettingsGroup, { title: "Medidas" }, {
        default: _withCtx(() => [
          _createVNode(_component_Setting, {
            description: "Determina el tamaño de la rejilla",
            name: "Tamaño rejilla"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Number, {
                modelValue: _ctx.gridMeasure,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.gridMeasure = $event)),
                max: "99",
                min: "2",
                step: "2"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Setting, {
            description: "Determina la orientación del folio",
            name: "Orientación folio"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TGSelect, {
                modelValue: _ctx.gridOrientation,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.gridOrientation = $event)),
                options: _ctx.gridOrientationOptions
              }, null, 8, ["modelValue", "options"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_SettingsGroup, { title: "Herramientas" }, {
        default: _withCtx(() => [
          _createVNode(_component_Setting, {
            description: "Si está activado, después de crear una línea se empezará otra automáticamente",
            name: "Línea automática"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TgToggle, {
                modelValue: _ctx.continueLine,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.continueLine = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_SettingsGroup, { title: "Rejilla" }, {
        default: _withCtx(() => [
          _createVNode(_component_Setting, {
            description: "Muestra la rejilla en el fondo",
            name: "Mostrar rejilla"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TgToggle, {
                modelValue: _ctx.showGridHelper,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showGridHelper = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Setting, {
            disabled: !_ctx.showGridHelper,
            description: "Determina el color de la rejilla",
            name: "Color rejilla"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                style: _normalizeStyle({ backgroundColor: _ctx.helperColorPicker }),
                class: "color-picker-box",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showGridHelperColorPicker = _ctx.showGridHelper && !_ctx.showGridHelperColorPicker))
              }, null, 4),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.showGridHelperColorPicker && _ctx.showGridHelper)
                    ? (_openBlock(), _createBlock(_component_color_picker, {
                        key: 0,
                        color: _ctx.helperColorPicker,
                        "show-alpha": false,
                        "sucker-hide": true,
                        class: "color-picker",
                        theme: "light",
                        onChangeColor: _cache[5] || (_cache[5] = ($event: any) => (_ctx.helperColorPicker = $event.hex))
                      }, null, 8, ["color"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_Setting, {
            description: "Muestra los ejes de la rejilla",
            name: "Mostrar ejes"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TgToggle, {
                modelValue: _ctx.showGridAxis,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.showGridAxis = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Setting, {
            disabled: !_ctx.showGridAxis,
            description: "Determina el color de los ejes de la rejilla",
            name: "Color ejes"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                style: _normalizeStyle({ backgroundColor: _ctx.axisColorPicker }),
                class: "color-picker-box",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showGridAxisColorPicker = _ctx.showGridAxis && !_ctx.showGridAxisColorPicker))
              }, [
                (_ctx.showGridAxisColorPicker && _ctx.showGridAxis)
                  ? (_openBlock(), _createBlock(_component_color_picker, {
                      key: 0,
                      color: _ctx.axisColorPicker,
                      "show-alpha": false,
                      "sucker-hide": true,
                      class: "color-picker",
                      theme: "light",
                      onChangeColor: _cache[7] || (_cache[7] = ($event: any) => (_ctx.axisColorPicker = $event.hex))
                    }, null, 8, ["color"]))
                  : _createCommentVNode("", true)
              ], 4)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_SettingsGroup, { title: "Autoguardado" }, {
        default: _withCtx(() => [
          _createVNode(_component_Setting, {
            description: "Guarda el dibujo automáticamente cada cierto intervalo de tiempo en el navegador",
            name: "Autoguardado"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TgToggle, {
                modelValue: _ctx.autoSaveActive,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.autoSaveActive = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Setting, {
            disabled: !_ctx.autoSaveActive,
            description: "Determina el intervalo en el que se guarda en minutos",
            name: "Intervalo de autoguardado"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Number, {
                modelValue: _ctx.autoSaveTimeInterval,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.autoSaveTimeInterval = $event)),
                disabled: !_ctx.autoSaveActive,
                max: "30",
                min: "1",
                step: "1"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_Setting, {
            name: "Guardado al salir",
            description: "Guarda el dibujo automáticamente antes de salir de la página en el navegador"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TgToggle, {
                modelValue: _ctx.saveOnExit,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.saveOnExit = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_SettingsGroup, { title: "Paleta de colores" }, {
        default: _withCtx(() => [
          _createVNode(_component_Setting, {
            name: "Guardar paleta",
            description: "Guarda la actual paleta de colores en un archivo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TgButton, { onClick: _ctx.savePalette }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_Setting, {
            name: "Cargar paleta",
            description: "Carga una paleta de colores desde un archivo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TgButton, {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$refs.fileLoader.click()))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createElementVNode("input", {
                id: "paletteFileInput",
                type: "file",
                accept: "application/json",
                style: {"display":"none"},
                ref: "fileLoader",
                onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.loadPalette && _ctx.loadPalette(...args)))
              }, null, 544)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show", "onClose"]))
}